import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-reservation-confirmation',
  templateUrl: './reservation-confirmation.component.html',
  styleUrls: ['./reservation-confirmation.component.scss']
})
export class ReservationConfirmationComponent implements OnInit {

  constructor(
    public matDialog : MatDialog,
    public dialogRef: MatDialogRef<ReservationConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    ) { }

    session: any;

  closeModal() {
    this.matDialog.closeAll()
  }

  ngOnInit(): void {
    this.session = this.modalData
  }
}
